import { Component } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { ApplicationService } from '../application.service';

@Component({
  selector: 'idl-versions',
  template: `
    <mat-card appearance="outlined" *ngIf="application$ | async as application">
      <mat-card-header>
        <mat-card-title> {{ application.name }} Versions </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <idl-versions-content
          [application]="application"
          [edit]="true"
        ></idl-versions-content>
      </mat-card-content>
    </mat-card>
  `
})
export class VersionsComponent {
  application$: Observable<any>;

  constructor(
    private _applicationService: ApplicationService,
    private _route: ActivatedRoute
  ) {
    this.application$ = this._route.parent.paramMap.pipe(
      take(1),
      switchMap((params: ParamMap) =>
        this._applicationService.getApp(+params.get('id'))
      )
    );
  }
}
